import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import {
  Business,
  Person,
  Security,
  Menu as MenuIcon,
} from '@mui/icons-material';
import axios from 'axios';
import React, { useEffect } from 'react';
import { API_BASE_URL } from '../../config';

import LanguagePicker from '@/components/LanguagePicker/LanguagePicker';

import { ExitToAppRounded, ExpandMore } from '@mui/icons-material';

export const handleLogout = async () => {
  localStorage.removeItem('appState');
  localStorage.removeItem('adminPermissions');
  try {
    const response = await axios.post(`${API_BASE_URL}/users/signout`);
    // TODO: check if still needed in CNE-1435
    if (response.data.logoutUrl) {
      window.location.href = response.data.logoutUrl;
    } else {
      if (response?.data?.redirectTo) {
        window.location.href = `/user/${
          response.data.redirectTo === 'admin'
            ? 'login'
            : 'facilitylogin' + '?redirect=' + window.location.pathname
        }`;
      } else {
        window.location.href = `/user/facilitylogin`;
      }
    }
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

export default function AdminNavbarLinks({
  uiRole,
  handleDrawerToggle,
  isMobile,
}) {
  const [user, setUser] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const organizationName = localStorage.getItem('organizationName') || '';
  const userName = localStorage.getItem('userName') || '';

  const permissionsType = user?.permissionsType || '';
  const roleName = user?.roleName || '';

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    handleLogout();
  };

  useEffect(() => {
    let state = localStorage['appState'];
    let AppState;
    if (state) {
      AppState = JSON.parse(state);
    }
    setUser(AppState && AppState.user && AppState.user);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        background: 'white',
        padding: '8px 8px',
      }}>
      {isMobile && (
        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='start'
          onClick={handleDrawerToggle}
          sx={{ mr: 2, color: 'text.primary' }}>
          <MenuIcon />
        </IconButton>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          bgcolor: 'background.paper',
          color: 'text.secondary',
          p: 0.5,
          ml: 'auto',
        }}>
        {organizationName && uiRole !== 'admin' && (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                paddingX: 1,
                paddingY: 0.5,
              }}>
              <Business sx={{ fontSize: 18, color: 'primary.main' }} />
              <Typography
                variant='body2'
                sx={{
                  color: 'text.primary',
                  display: { xs: 'none', sm: 'block' },
                }}>
                {organizationName}
              </Typography>
            </Box>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ mr: 0.5 }}
            />
          </>
        )}

        {permissionsType === 'role' && roleName && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              paddingX: 1,
              paddingY: 0.5,
            }}>
            <Security sx={{ fontSize: 18, color: 'primary.main' }} />
            <Typography
              variant='body2'
              sx={{
                color: 'text.primary',
                display: { xs: 'none', sm: 'block' },
              }}>
              {roleName}
            </Typography>
          </Box>
        )}

        {permissionsType === 'role' && roleName && (
          <Divider
            orientation='vertical'
            variant='middle'
            flexItem
            sx={{ mr: 0.5 }}
          />
        )}

        <Box>
          <LanguagePicker />
        </Box>

        <Divider orientation='vertical' variant='middle' flexItem />

        <Box>
          <IconButton
            onClick={handleClick}
            size='small'
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              paddingX: 1,
              paddingY: 0.5,
              borderRadius: 2,
            }}>
            <Person sx={{ fontSize: 18, color: 'primary.main' }} />
            <Typography
              variant='body2'
              sx={{
                color: 'text.primary',
                display: { xs: 'none', sm: 'block' },
              }}>
              {uiRole === 'admin' ? 'Admin' : userName}
            </Typography>
            <ExpandMore fontSize='small' sx={{ color: 'text.secondary' }} />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            id='account-menu'
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
            <MenuItem onClick={handleLogoutClick}>
              <ListItemIcon>
                <ExitToAppRounded
                  fontSize='small'
                  sx={{ color: 'error.main' }}
                />
              </ListItemIcon>
              <Typography variant='body2'>Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
}
